import { MdLocalHospital, MdLocationOn, MdVerified } from 'react-icons/md';

export default function ClientsSection() {
  return (
    <section className="HospiumSection HospiumClients">
      <div className="container">
        <div className="HospiumSectionIntro"><span className="HospiumKicker">Existing client</span><h2>Trusted in a real care setting</h2><p>Hospium is being shaped around the operational needs of healthcare providers.</p></div>
        <article className="HospiumClientCard">
          <div className="HospiumClientIcon"><MdLocalHospital /></div>
          <div><span className="HospiumClientBadge"><MdVerified /> Hospium client</span><h3>Dr Msua Polyclinic</h3><p><MdLocationOn /> Musoma, Mara, Tanzania</p></div>
        </article>
      </div>
    </section>
  );
}
